import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.css";
import { ROUTES } from "../../utils/routes";

const footerShape = process.env.PUBLIC_URL + '/images/fotrshp.png';
const logo = process.env.PUBLIC_URL + '/images/logo.png';

const quickLinks = [
  { label: "Solutions", href: "#services", isAnchor: true },
  { label: "Industries", path: ROUTES.INDUSTRIES },
  { label: "Resources", href: "#blog", isAnchor: true },
  { label: "About", path: ROUTES.ABOUT },
  { label: "Why MS Tech", path: ROUTES.WHY_MS_TECHNOLOGIES },
];

const legalLinks = [
  { label: "Privacy Policy", href: "#" },
  { label: "Terms of Use", href: "#" },
  { label: "Trademark Notice", href: "#" },
  { label: "Cookie Notice", href: "#" },
];

const socials = [
  { icon: "bi-facebook", href: "#", label: "Facebook" },
  { icon: "bi-instagram", href: "#", label: "Instagram" },
  { icon: "bi-linkedin", href: "#", label: "LinkedIn" },
];

export default function Footer() {
  const navigate = useNavigate();

  const handleAnchorScroll = (id) => {
    // If on home page, scroll to section
    // Otherwise navigate home and then scroll
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleNavigate = (path) => {
  navigate(path);
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

return (
  <footer className="footer-section">

    {/* Main Footer */}
    <div className="footer-main">
      <div className="ftrshpe">
        <img src={footerShape} alt="shape" />
      </div>

      <div className="footer-circuit" />

      <div className="container">
        <div className="row g-5 align-items-start">

          {/* Brand */}
          <div className="col-lg-4 col-md-12 relative">
            <Link to={ROUTES.HOME} className="footer-logo-wrap">
              <img
                src={logo}
                alt="MS Technologies"
                className="footer-logo-img"
              />
            </Link>

            <p className="footer-desc">
              MS Technologies is an enterprise SAP, data, AI, and digital innovation consulting firm focused on finance-led modernization and scalable transformation.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-4 col-sm-6 relative">
            <h5 className="footer-heading">QUICK LINKS</h5>

            <ul className="footer-links">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  {l.isAnchor ? (
                    <button
                      className="footer-link footer-link-btn"
                      onClick={() =>
                        handleAnchorScroll(l.href.substring(1))
                      }
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <i className="bi bi-chevron-right" /> {l.label}
                    </button>
                  ) : (
                    <Link
                      to={l.path}
                      className="footer-link"
                    >
                      <i className="bi bi-chevron-right" /> {l.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div className="col-lg-2 col-md-4 col-sm-6 relative">
            <h5 className="footer-heading">LEGAL</h5>

            <ul className="footer-links">
              {legalLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="footer-link">
                    <i className="bi bi-chevron-right" /> {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div className="col-lg-4 col-md-4 col-sm-12 text-center relative">
            <h5 className="footer-heading">
              GET CONNECT WITH US
            </h5>

            <div className="footer-socials">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="footer-social-icon"
                  aria-label={s.label}
                >
                  <i className={`bi ${s.icon}`} />
                </a>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>

    {/* Copyright */}
    <div className="footer-bottom">
      <p>&copy; 2026 MS Technologies &amp; Financials</p>
    </div>

  </footer>
);
}